//When chaning from dev to prod, also change this
const WS = "/ws";
// Url location should change automatically
// If REACT_APP_BACKEND_URL is set (e.g. a real prod/staging domain), it always wins.
// Otherwise, fall back to whatever host this page was actually loaded from, on port 8080 --
// so opening the dev server via localhost, a LAN IP, or a hostname all just work,
// including when that IP changes later, with no rebuild needed.
const AUTH_URL =
  process.env.REACT_APP_BACKEND_URL ||
  `${window.location.protocol}//${window.location.hostname}:8080`;

// DO NOT EXPORT THE ABOVE STRINGS
export const BASE_URL = AUTH_URL;
export const WS_BASE_URL = AUTH_URL + WS;
export const REGISTER = "register";
export const LOGIN = "login";
export const LOGOUT = "/auth/logout";
export const REFRESH = "/auth/refresh";
export const VERIFY = "/verify";
export const RESEND_VERIFICATION_EMAIL = "/resendVerification";
export const DELETE_ACCOUNT_REQUEST = "/delete_account"
export const DELETE_ACCOUNT_CONFIRMATION = "/delete_account/confirmation"
export const BOOKING = "/appointments/";
export const USER_INFINITE_APPOINTMENTS =
  BOOKING + "user/appointments/infinite";
export const PET_INFINITE_APPOINTMENTS = BOOKING + "pet/appointments/infinite";
export const BOOKED_TIME = BOOKING + "booked/clinic/";
export const CLINIC_APPOINTMENTS = BOOKING + "clinic/";
export const CLINIC_APPOINTMENTS_TABLE = BOOKING + "clinic/table";
export const ACCEPT_APPOINTMENT = BOOKING + "accept/";
export const REJECT_APPOINTMENT = BOOKING + "reject/";
export const PENDING_APPOINTMENTS = "/appointments/pending/count/clinic/";
export const PENDING_APPOINTMENTS_PAGING = "/appointments/pending/paging";
export const REVERT_APPOINTMENT = "/appointments/revert/";
export const PENDING_APPOINTMENTS_HOMEPAGE_API =
  "/appointments/pending/list/clinic/homepage";

// FEEDBACK ENDPOINTS
export const FEEDBACK = "/feedback/"
export const FEEDBACK_FROM = `${FEEDBACK}from/`
export const CLINIC_FEEDBACKS_LIST = `${FEEDBACK_FROM}clinics`
export const USER_FEEDBACKS_LIST = `${FEEDBACK_FROM}users`
export const FEEDBACK_MARK = `${FEEDBACK}mark/`
export const MARK_ALL_READ = `${FEEDBACK_MARK}all/read`
export const FETCH_USER_RATING = `${FEEDBACK_FROM}single/user`

//WORKING DAY ENDPOINTS
export const TREATMENT_UPDATING = "/treatment/update/";
export const GET_WORKING_DAYS = "/clinics/working_days/";
export const EDIT_WORKING_DAYS = "/clinics/edit/working_days/";
// More accurate name would be PET_API but okey
export const ADD_PET = "/pets/";
export const DECEASED_PET = ADD_PET + "deceased/"
export const ADD_PET_TO_USER = "/pets/user/";
export const PET_APPOINTMENTS = ADD_PET + "appointments/";
export const EDIT_PROFILE = "/user/edit/";
export const EDIT_USER_PREFERENCES = "/users/preferences/";
export const TREATMENT = "/treatment/";
export const TEMPLATE = "/template/";
export const CLINICS_TEMPLATES = "/template/clinic/";
export const CLINICS_TEMPLATES_DROPDOWN = "/template/clinic/dropdown/";
export const PRESCRIPTION_TEMPLATE = "/prescription-template/";
export const CLINICS_PRESCRIPTION_TEMPLATES = "/prescription-template/clinic/";
export const REFERRAL_TEMPLATE = "/referral-template/";
export const CLINICS_REFERRAL_TEMPLATES = "/referral-template/clinic/";
export const INSTITUTION = "/institution/";
export const CLINICS_INSTITUTIONS = "/institution/clinic/";
export const CHANGE_PASSWORD = "/changePassword";
export const CHANGE_PASSWORD_WITH_TOKEN = CHANGE_PASSWORD + "/token";
export const CHANGE_EMAIL = "/changeEmail";
export const CHANGE_EMAIL_WITH_TOKEN = CHANGE_EMAIL + "/token";
export const DELETE_IMG = "/file/img/delete/";
export const FORGOTTEN_PASSWORD = "/forgotPassword";
export const VERIFY_NEW_EMAIL = "/changeEmail/verify";
export const PENDING_APPOINTMENTS_COUNT = BOOKING + "pending/count";
export const UNRED_CONVOS_COUNT = "/inbox/unread/convos";
export const INBOX_MULTIPLE = "/inbox/send/multiple/"
export const OPEN_CONVO = "/inbox/conversation/"
export const LOGO_UPLOAD = "/file/upload/img/logo/";
export const ABOUT_US_UPLOAD = "/file/upload/img/about_us/";
export const CLINIC_USERS = "/users/clinic/";
export const CLINIC_USERS_ALL = "/users/clinic/all";
export const CLINIC_USERS_CHANGE = "/users/clinic/change/";
export const DOWNLOAD_IMG = "/file/download/img/";
export const CLINICS = "/clinics/";
export const CLINICS_EDITING = "/clinics/edit";
export const CLINIC_LIST = "/clinics/list";
export const CLINIC_INFO = "/clinics/info";
export const CLINIC_DTO = CLINICS + "single/";
export const EMPLOYEE_ACTIVATION = "/employee/activate?token=";
export const USER_ACTIVATION = "/user/activate";
export const USER_ACTIVATION_CONFIRM = "/user/activate/confirm?token=";
export const PRICES_BASE_REQUEST = "/prices/clinic/";
export const PRICE_DELETE_ID = PRICES_BASE_REQUEST + "price/";
export const CLINIC_WORKING_HOURS = "/clinics/working_days/working/";
export const WORKING_DAYS_DTO = "/clinics/working_days/dto/";
export const NON_WORKING_DAY_DELETE_ID = "/clinics/working_days/delete/";
export const POST_NON_WORKING_DATE = "/clinics/non_working_days/";
export const PETS_DROPDOWN = "/pets/clinic/user/booking_modal/dropdown";
export const APPOINTMENT_DTO = "/appointments/appointment/details/dto/";
export const PET_DTO = "/pets/dto/";
export const CLINIC_USER_DETAILS = "/users/details/";
export const EMPLOYEES = "/clinics/employees/";
export const CLINIC_PETS = ADD_PET + "clinic/";
export const CHECK_CLINIC_SHORT_NAME = CLINICS + "shortName/";
export const SPECIES = "/species";
export const SPECIES_SAVE = SPECIES + "/save";
export const SPECIES_ADD_TO_CLINIC = SPECIES + "/clinic/add/";
export const SPECIES_CLINIC_DTO = SPECIES + "/clinic/";
export const SPECIES_ACTIVATION = SPECIES + "/";
export const SPECIES_DELETE = SPECIES + "/delete/";
export const SPECIES_BOOKING_MODAL =
  SPECIES + "/clinic/booking_modal/pet_species";
export const PROFILE_DTO = "/users/profile";
export const SEND_CLINIC_SMS = "/clinics/send_sms/";
export const GET_DOCUMENT_CATEGORIES = "/clinics/categories/";
export const INFORMATION_FIELD_REQUEST = "/clinics/information_field/";
export const ABOUT_US = "/clinics/about_us/";
export const ACTIVATE_CLINIC = "/clinics/activate/";
export const DEACTIVATE_CLINIC = "/clinics/deactivate/";
export const CLINIC_CATEGORIES = "/clinics/categories/";
export const CLINIC_CATEGORIES_DROPDOWN = "/clinics/categories/dropdown/";
export const CLINIC_CATEGORIES_MASTER = "/clinics/categories/master/";
export const APPOINTMENT_BIOMETRICS = "/appointments/biometrics/";
export const PET_BIOMETRICS = "/pets/biometrics/";
export const RECIPIENTS_LIST_FETCH = "/inbox/recipients/list";
export const DOWNLOAD_DR_LETTER = "/file/generate-pdf/doctors-letter/"
export const ATTACH_FILE_TO_PET_AND_APP = "/file/upload/appointment/list/"
export const ATTACH_FILE_TO_PET = "/file/upload/pet/files/"
export const FILE_DOWNLOAD = "/file/download/"
export const FILE_DELETE = "/file/delete/"
export const PET_NOTE_SUBMIT = "/pets/notes/";
export const PET_NOTE_DELETE = '/pets/notes/'
export const PET_USER_HOMEPAGE_DTO = ADD_PET + "homepage/dto/";
export const APPOINTMENT_USER_HOMEPAGE_DTO =
  BOOKING + "appointment/homepage/dto";
export const PET_AVATAR = "avatar/";
export const PET_AVATAR_UPLOAD = "/file/upload/pet/profile/";
export const PET_AVATAR_DELETE = "/file/delete/pet/avatar/";
export const EMPLOYEE_PERMISSIONS = "/permissions/employee/";
export const CLINIC_PERMISSIONS = "/permissions/clinic/";
export const TIERS = "/tiers/";
export const USER_ROLES="/users/role/"
export const GET_WAREHOUSE= "/warehouse/clinic/";
export const GET_WAREHOUSE_ITEMS = "/warehouse/clinic/items/";
export const GET_WAREHOUSE_ITEM = "/warehouse/items/";
export const GET_WAREHOUSE_SUPPLIERS = "/warehouse/clinic/suppliers/";
export const GET_WAREHOUSE_CATEGORIES = "/warehouse/clinic/categories/";
export const GET_WAREHOUSE_ITEM_AUDITING = "/warehouse/items/";
export const WAREHOUSE_SUPPLIER = "/warehouse/suppliers/";
export const WAREHOUSE_CATEGORY = "/warehouse/categories/";
export const WAREHOUSE_CODE_PREFIX = "/warehouse/code-prefix/";
export const WAREHOUSE_PREFERENCES = "/warehouse/preferences/";
export const WAREHOUSE_LABELS_BATCH = "/warehouse/items/labels";
export const WAREHOUSE_SHOPPING_LIST = "/warehouse/items/shopping-list";
export const INVOICE_SETTINGS = "/invoice/settings/";
export const GET_THERAPIES_LIST = "/therapy/list/all/"
export const GET_ARCHIVED_THERAPIES_LIST = "/therapy/list/all/archived/"
export const ADD_NEW_THERAPY = "/therapy/new/therapy"
export const FINISH_THERAPY = "/therapy/finish/";
export const GET_SINGLE_BOX = "/saps/box/single/"
export const GET_SINGLE_ARCHIVE = '/inpatient/archive/'
export const GET_SINGLE_ARCHIVE_VIEW = '/inpatient/archive/view/'
export const GET_BLOOD_DONORS = "/pets/blood_donors/"
export const THERAPY_ALERTS = "/therapy/alerts/" 
export const MARK_THERAPY_AS_DONE = "/therapy/done/therapies/"
export const GET_ARCHIVED_MEDICAL_DAYS_API = "/therapy/archived/medical_days/"
export const PUT_THERAPY_DAY = "/therapy/update/therapy_days"
export const GET_THERAPY_DAYS = "/therapy/therapy_days/";
export const DELETE_THERAPY = "/therapy/delete/"
export const GET_SINGLE_THERAPY_DAY_BY_DATE = "/therapy/single/day?therapyId="
export const GET_APPOINTMENT_TIME_SLOTS = BOOKING + "timeSlots?";
export const GET_QR_REDIRECT = "/qr/redirect/";
export const GET_URL_REDIRECT_LINK = "/qr/info/";
export const GET_QR_IMAGE = "/qr/image/" 
export const DOWNLOAD_QR_IMAGE = "/qr/image/" 
//SAPS
export const GET_SINGLE_THERAPY = "/therapy/single/";
export const GET_BOXES = "/saps/box/all/clinic/"
export const PET_MEDICAL_OVERVIEW_SUMMARY = "/saps/box/medical_overview/summary/";
export const GET_SINGLE_PET_IN_BOX = "/saps/box/get/pet/";
export const SAPS_PET_NOTES = "/saps/box/notes/";
export const SAPS_ADD_PET_NOTE = "/saps/box/add/note/";
export const EDIT_INPATIENT_STAY = "/inpatient/save";
export const GET_INPATIENT_STAY = "/inpatient/pet/";
export const SET_RESPONSIBLE_VET = "/inpatient/add/responsible/veterinarian"
export const PET_MEDICAL_TREATMENT_SUMMARY = "/saps/box/medical_overview/summary/treatment/";
export const GET_PET_RECORDS = "/therapy/all/"
export const REMOVE_PET_FROM_BOX = "/saps/box/pet/remove/" 
export const GET_THERAPY_DAY_DATES = "/therapy/list/all/dates/" 
export const DELETE_BOX = "/saps/box/delete/"
export const ADD_PET_TO_BOX = "/saps/box/add/pet/"
export const GENERATE_DR_LETTER = "/file/generate-pdf/doctors-letter/"
export const ADD_CLINIC = "/clinics/add/to/user"
export const GET_ARCHIVE_LIST = "/inpatient/archive/list"
export const DOWNLOAD_ARCHIVED_LIST = "/inpatient/export/csv"
export const ARCHIVE_BOX = "/inpatient/archive/";
export const UNARCHIVE_BOX = "/inpatient/unarchive/";
export const DELETE_USER="/clinics/user/delete/"
export const ACTIVATE_USER = "/users/activation/";
export const BLOCK_USER = "/users/block/";
export const UNBLOCK_USER = "/users/unblock/";
export const AVAILABLE_BOXES_FOR_MOVE = "/saps/box/available/for/switching/";
export const AVAILABLE_BOXES = "/saps/box/available/";
export const MOVE_PET_TO_BOX = "/saps/box/move/pet";
export const GET_ALL_VETS = "/users/all/veterinarians"
export const GET_ACTIVE_THERAPIES_LIST = "/therapy/list/all/active";
export const WAREHOUSE_ITEM_SUBMIT = "/warehouse/clinic/items/";
export const ASSIGN_RESOURCE_TO_SERVICE_API = "/prices/assign/resources/";
export const GET_RESOURCES = "/prices/get/resources/"
export const IMPORT_USERS = "/users/import"
export const IMPORT_USERS_CHECK = "/users/import/check"
export const DOWNLOAD_INVOICE = "/appointments/invoice/"